<ngx-skeleton-loader
  [theme]="{height: '500px', width:'100%', 'border-radius':'0', margin: '0px'}"
  appearance="circle"
></ngx-skeleton-loader>
<ngx-skeleton-loader
  [theme]="{height: '255px', width:'100%', 'border-radius':'0', margin: '0px'}"
  appearance="circle"
></ngx-skeleton-loader>
